module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-lo"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "lo-modal-title"
  }, [_vm._v("XEM GIẢI THÍCH CHI TIẾT TỪNG CÂU HỎI")]), _c('span', {
    staticClass: "lo-modal-btn-close material-icons",
    on: {
      "click": _vm.closePopupPayment
    }
  }, [_vm._v("close")])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "reg-content"
  }, [_vm._v("Để xem giải thích chi tiết từng câu hỏi cho bài tập này bạn cần thanh toán:")]), _c('div', {
    staticClass: "board-payment"
  }, [_c('div', {
    staticClass: "text-honey"
  }, [_vm._v("Hũ mật ong")]), _c('div', {
    staticClass: "number-honey"
  }, [_c('span', [_vm._v(_vm._s(_vm.$mycontroller.numberWithCommas(_vm.amount)))]), _c('img', {
    attrs: {
      "src": require("../../../../assets/images/achieve/ic_honeyJars.png")
    }
  })])])]), _c('div', {
    staticClass: "modal-footer lo-custom-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-12 text-center"
  }, [_c('a', {
    staticClass: "lo-btn-continue lo-popup-pc btn",
    on: {
      "click": function($event) {
        return _vm.continuteConfirmPayment()
      }
    }
  }, [_vm._v("Xác nhận")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19bad7f8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/LandingPage/Exercise/popupPayment.vue
// module id = 1497
// module chunks = 0